// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SetNickname from "./pages/SetNickname";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import Chat from "./pages/Chat";
import RoomList from "./pages/RoomList";
import RoomChat from "./pages/RoomChat";
import CreateRoom from "./pages/CreateRoom";
import { SocketContextProvider } from "./contexts/SocketContext";


function App() {
  return (
    <BrowserRouter>
      <SocketContextProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/set-nickname" element={<SetNickname />} />

          {/* Layout + 중첩 라우트 */}
          <Route element={<Layout />}>
            <Route
              path="chat"
              element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              }
            />
            <Route
              path="rooms"
              element={
                <PrivateRoute>
                  <RoomList />
                </PrivateRoute>
              }
            />
            <Route
              path="chat-room/:roomId"
              element={
                <PrivateRoute>
                  <RoomChat />
                </PrivateRoute>
              }
            />
            <Route
              path="create-room"
              element={
                <PrivateRoute>
                  <CreateRoom />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </SocketContextProvider>
    </BrowserRouter>
  );
}

export default App;
